import { render, staticRenderFns } from "./drawer_Change.vue?vue&type=template&id=395a559c&scoped=true&"
import script from "./drawer_Change.vue?vue&type=script&lang=js&"
export * from "./drawer_Change.vue?vue&type=script&lang=js&"
import style0 from "./drawer_Change.vue?vue&type=style&index=0&id=395a559c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395a559c",
  null
  
)

export default component.exports